<!-- Loading and error -->
<app-loading-status *ngIf="loaderService.isLoading | async; else notLoading"></app-loading-status>
<app-alert-status *ngIf="loadingError" [loadingError]="loadingError"></app-alert-status>

<ng-template #notLoading>
  <ng-container *ngIf="!currentProduct">
    <ng-container *ngIf="{ darkMode: darkMode$ | async } as ui">
      <div class="container-fluid">
        <div class="row justify-content-center pt-5">
          <div class="col-md-11 col-12">

            <!-- Heading, search and year -->
            <div class="row align-items-end mt-5 mb-4">
              <div class="col-lg-5 col-12" *ngIf="layout">
                <app-area-heading [heading]="layout.heading" [subheading]="layout.subheading"
                  [backRoute]="layout.backRoute"></app-area-heading>
              </div>

              <div class="col-lg-7 col-12 d-flex justify-content-lg-end mt-3 mt-lg-0">
                <div class="input-group product-search mr-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text" [ngClass]="{'bg-dark-700 text-light border-dark': ui.darkMode}">
                      <i class="far fa-search"></i>
                    </span>
                  </div>
                  <input type="text" class="form-control" placeholder="Search products" aria-label="Search products"
                    [ngClass]="{'bg-dark-700 text-light border-dark': ui.darkMode}"
                    [(ngModel)]="searchTerm" (ngModelChange)="applySearch()">
                  <div class="input-group-append" *ngIf="searchTerm">
                    <button class="btn btn-outline-secondary" type="button" (click)="clearSearch()" aria-label="Clear search">
                      <i class="far fa-times"></i>
                    </button>
                  </div>
                </div>
                <app-year-select (emitCurrentYear)="yearChange($event)"></app-year-select>
              </div>
            </div>

            <!-- Result count -->
            <div class="mb-3 text-secondary" *ngIf="products.length">
              Showing {{ filteredProducts.length }} of {{ products.length }} products for {{ currentYear }}
            </div>

            <!-- Product cards -->
            <div class="row">
              <div class="col-xl-3 col-lg-4 col-md-6 col-12 mb-4 d-flex align-items-stretch"
                *ngFor="let product of filteredProducts; trackBy: trackByProductId">
                <div class="card product-card w-100" role="button" tabindex="0"
                  [ngClass]="{'bg-dark-700 text-light border-dark': ui.darkMode}"
                  (click)="openProduct(product)" (keydown.enter)="openProduct(product)"
                  (keydown.space)="openProduct(product)">
                  <div class="card-body d-flex flex-column">
                    <div class="d-flex justify-content-between align-items-start mb-3">
                      <span class="badge product-alias" [ngClass]="{'badge-light': ui.darkMode, 'badge-primary': !ui.darkMode}">
                        {{ product.productAlias }}
                      </span>
                      <i class="far fa-angle-right product-chevron"
                        [ngClass]="{'text-light': ui.darkMode, 'text-secondary': !ui.darkMode}"></i>
                    </div>
                    <h5 class="card-title product-name mb-0" [ngClass]="{'text-light': ui.darkMode}">
                      {{ product.productName }}
                    </h5>
                    <div class="mt-auto pt-3 small" [ngClass]="{'text-light': ui.darkMode, 'text-secondary': !ui.darkMode}">
                      View {{ currentYear }} organisations
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- No search results -->
            <div class="text-center py-5" *ngIf="products.length && !filteredProducts.length">
              <i class="far fa-search fa-2x mb-3" [ngClass]="{'text-light': ui.darkMode, 'text-secondary': !ui.darkMode}"></i>
              <div [ngClass]="{'text-light': ui.darkMode, 'text-secondary': !ui.darkMode}">
                No products match "{{ searchTerm }}".
              </div>
              <button class="btn btn-link" (click)="clearSearch()">Clear search</button>
            </div>

          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-container *ngIf="currentProduct">
  <app-products-detail [currentProduct]="currentProduct" [currentYear]="currentYear"></app-products-detail>
</ng-container>
